import { UiAction } from './action.types';
import { DynamicTitle, SettingsProvider } from './common.types';
import { Content, ExportOptions, CollectionOptions, GenAiOptions } from './content.types';
import { DataOptions } from './data.types';
import { NoDataInfoType } from '../../bff/content/component';

export type CallToAction = {
  isPrimary?: boolean;
  label: string;
  action: UiAction;
};

export enum DataVizType {
  table = 'table',
  chart = 'chart',
  horizontalBarChart = 'horizontalBarChart',
  verticalBarChart = 'verticalBarChart',
  stackedBarChart = 'stackedBarChart',
  bubbleChart = 'bubbleChart',
  valueWithChangeChart = 'valueWithChangeChart',
  lineChart = 'lineChart',
}

export enum DataVizName {
  table = 'Table',
  chart = 'Bar Chart',
  horizontalBarChart = 'Horizontal Bar Chart',
  verticalBarChart = 'Vertical Bar Chart',
  stackedBarChart = 'Stacked Bar Chart',
  bubbleChart = 'Bubble Chart',
  valueWithChangeChart = 'Value with Change Chart',
  lineChart = 'Line Chart',
}

export enum MoBillboardDataType {
  BrandName = 'brand_name',
  BrandOwnerName = 'brand_owner_name',
}

export interface DataVizConfig {
  type: DataVizType;
  name: DataVizName;
  isDisabled?: boolean;
  tooltipContent?: string;
}

export type ComponentHeading = {
  subTitle?: string;
  title?: string | DynamicTitle;
  isCollapsible?: boolean;
  isFilterDisabled?: boolean;
};

export type ComponentLayout = 'vertical-list' | 'horizontal-list' | 'flex-grid' | 'adaptive-grid';

export type Component = {
  name: string;
  heading?: ComponentHeading;
  callsToAction?: CallToAction[];
  dataOptions?: DataOptions;
  contents: {
    fixed?: Content[];
    endpoint?: string;
    aboveFold?: number;
  };
  settings: SettingsProvider;
  asCard?: boolean;
  noDataInfoType?: NoDataInfoType;
  layout?: ComponentLayout;
  exportOptions?: ExportOptions;
  collectionOptions?: CollectionOptions;
  genAiOptions?: GenAiOptions;
};
